/**
 * ack is an internal reserved protocol field (previously named ackMeta).
 *
 * Semantics (ACK-only workflow):
 * - If `ack` exists, it should contain a required `id` (string|number) for matching.
 * - Fixed shape: { id, meta?: string } (meta is optional and must be a string if present).
 * - Matching is by `id` only; never deep-compare other fields.
 *
 * @internal
 */
export function getAckId(ack) {
  if (!ack || typeof ack !== 'object') return undefined;
  var id = ack.id;
  return typeof id === 'string' || typeof id === 'number' ? id : undefined;
}

/**
 * @internal
 */
export function getAckMeta(ack) {
  if (!ack || typeof ack !== 'object') return undefined;
  var meta = ack.meta;
  return typeof meta === 'string' ? meta : undefined;
}

/**
 * Match ack by `id` only.
 * @internal
 */
export function isAckMatch(expected, received) {
  if (expected === undefined) return true;
  var expectedId = getAckId(expected);
  var receivedId = getAckId(received);
  if (expectedId === undefined || receivedId === undefined) return false;
  return expectedId === receivedId;
}